export const PRODUCT = {
  HOME: 'product',
  VISIBLE_BY_VERIZON_DRAWER: 'visible_by_verizon_drawer',
  EXTERNAL_PAGE_VERIFIED_REFURBISHED: 'verified-refurbished',
}
